import { FinancialDisclaimerType } from '~/app/market-config/models/financial-disclaimer-type';
import { CarlineQuery } from '~/graphql/__generated__/graphql';

const getMonthlyRateDisclaimer = (
	data: { carline: CarlineQuery | undefined; isLoadingCarline: boolean },
	configuredDisclaimers: Array<FinancialDisclaimerType>,
	configuredModelCode?: string,
) => {
	if (!configuredDisclaimers) return '';
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	let modelForDisclaimer: any = {};

	data?.carline?.configuredCar?.carlineStructureCarline?.trimlines.forEach((trimline) => {
		trimline.models.forEach((model) => {
			if (model.modelId.code === configuredModelCode) {
				modelForDisclaimer = model;
			}
		});
	});

	if (!modelForDisclaimer.prices?.financingParameters.disclaimers) {
		return '';
	}

	const completeDisclaimerText =
		configuredDisclaimers
			.map((disclaimer) => modelForDisclaimer.prices?.financingParameters.disclaimers[disclaimer])
			.join(' ') ?? '';

	return completeDisclaimerText;
};

export { getMonthlyRateDisclaimer };
